import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, ExtraOptions } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { MockAuthGuard } from './mock-authgard';
import { environment } from '../environments/environment';

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always',
    preloadingStrategy: PreloadAllModules
};

const isCypress = environment.cypress;

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/logout/logout.module').then( m => m.LogoutPageModule),
  },
  {
    path: 'jobs',
    loadChildren: () => import('./pages/jobs/jobs.module').then( m => m.JobsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],

  },
  {
    path: 'availability',
    loadChildren: () => import('./pages/availability/availability.module').then( m => m.AvailabilityPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'skill-sets',
    loadChildren: () => import('./pages/technician/skillsets/skillsets.module').then( m => m.SkillsetsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'service-area',
    loadChildren: () => import('./pages/technician/servicearea/servicearea.module').then( m => m.ServiceareaPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'tickets',
    loadChildren: () => import('./pages/tickets/tickets.module').then( m => m.TicketsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'quotes',
    loadChildren: () => import('./pages/quotes/quotes.module').then( m => m.QuotesPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'job',
    loadChildren: () => import('./pages/job/job.module').then( m => m.JobPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'quote',
    loadChildren: () => import('./pages/quote/quote.module').then( m => m.QuotePageModule),
    canLoad: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'newquote/:id',
    loadChildren: () => import('./pages/newquote/newquote.module').then( m => m.NewquotePageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'customer',
    loadChildren: () => import('./pages/customer/customer.module').then( m => m.CustomerPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'ticket',
    loadChildren: () => import('./pages/ticket/ticket.module').then( m => m.TicketPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/inventory.module').then( m => m.InventoryPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'invoices',
    loadChildren: () => import('./pages/invoices/invoices.module').then( m => m.InvoicesPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'invoice',
    loadChildren: () => import('./pages/invoice/invoice.module').then( m => m.InvoicePageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'knowledge',
    loadChildren: () => import('./pages/knowledge/knowledge.module').then( m => m.KnowledgePageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'knowledgeSearch',
    loadChildren: () => import('./pages/knowledgeSearch/knowledgeSearch.module').then( m => m.KnowledgeSearchPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'knowledge/:id',
    loadChildren: () => import('./pages/knowledgeDetails/knowledgeDetails.module').then( m => m.KnowledgeDetailsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'errorPage',
    loadChildren: () => import('./pages/errorPage/error.module').then( m => m.ErrorPageModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/technician/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'skillsets',
    loadChildren: () => import('./pages/technician/skillsets/skillsets.module').then( m => m.SkillsetsPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  }, {
    path: 'servicearea',
    loadChildren: () => import('./pages/technician/servicearea/servicearea.module').then( m => m.ServiceareaPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'sms',
    loadChildren: () => import('./pages/technician/sms/technician-sms.module').then( m => m.TechnicianSMSPageModule),
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: 'contact',
    canActivate: [isCypress ? MockAuthGuard : AuthGuard],
  },
  {
    path: '**',
    redirectTo: '/login'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, routingConfiguration)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
